import React from "react";

import WsmFitmentQualifierListPage from "../components/WsmFitmentQualifierListPage";
import { useWsmFitmentQualifiers } from "../hooks/useWsmFitmentVocabulary";

export const WsmFitmentQualifierListView = () => {
  const { qualifiers, loading, error, retry } = useWsmFitmentQualifiers();

  return (
    <WsmFitmentQualifierListPage
      qualifiers={loading ? undefined : qualifiers}
      onRetry={error ? retry : undefined}
    />
  );
};

export default WsmFitmentQualifierListView;
